import { AxiosInstance } from "axios";
import { Shipper } from "../../models/shippers/shipper";
import API from "../../utils/api";
import {ShippingCourier} from "../../models/shipping/shipping";

export class ShipeprsService {
    private api: AxiosInstance = API;

    getShippers(): Promise<Shipper[]> {
        return this.api
            .get<Shipper[]>("delivery/shippers/all")
            .then((x) => x.data);
    }

    getCouriers(): Promise<ShippingCourier[]> {
        return this.api
            .get<ShippingCourier[]>("shipping/couriers")
            .then((x) => x.data);
    }
}

export const shippersService = new ShipeprsService();
